import axios from 'axios';
import { Dispatch } from 'redux';
import {
  getUnsignedApprovalDocDownloadDetails,
  getSignedApprovalDocDownloadDetails,
} from '../../graphql/queries';
import api from '../../services/api';
import {
  GET_ASSIGNED_APPROVAL_DOCS_REQUESTED,
  GET_ASSIGNED_APPROVAL_DOCS_COMPLETED,
  GET_ASSIGNED_APPROVAL_DOCS_FAILED,
} from './types';

type AuthMode = 'iam' | 'userPool';

function guestGetAssignedApprovalDocAction(
  ApprovalDocID: string,
  ContactID: string,
  authMode: AuthMode,
  document: { DocFileName?: string },
) {
  return async function action(dispatch: Dispatch) {
    dispatch({
      type: GET_ASSIGNED_APPROVAL_DOCS_REQUESTED,
    });
    let payload = {};

    try {
      if (document.DocFileName) {
        const { data } = await api.graphql({
          authMode,
          query: getSignedApprovalDocDownloadDetails,
          variables: {
            ApprovalDocID: document.DocFileName,
            ContactID,
            resourceId: ApprovalDocID,
          },
        });

        if (data.getSignedApprovalDocDownloadDetails?.Url) {
          const s3Response = await axios.get<{
            data: Blob;
          }>(data.getSignedApprovalDocDownloadDetails.Url, {
            responseType: 'blob',
          });

          const file = {
            Blob: s3Response.data,
            FileName: 'Financial Planning Agreement.pdf',
          };

          payload = {
            data: data.getSignedApprovalDocDownloadDetails,
            file,
          };
        } else {
          dispatch({
            type: GET_ASSIGNED_APPROVAL_DOCS_FAILED,
            payload: new Error('No document returned.'),
          });

          return;
        }
      } else {
        const { data } = await api.graphql({
          authMode,
          query: getUnsignedApprovalDocDownloadDetails,
          variables: {
            ContactID,
            ApprovalDocID,
          },
        });

        if (data?.getUnsignedApprovalDocDownloadDetails?.DocUrl) {
          const bucketResponse = await axios.get<{
            data: Blob;
          }>(data.getUnsignedApprovalDocDownloadDetails.DocUrl, {
            responseType: 'blob',
          });

          const file = {
            FileName: data.getUnsignedApprovalDocDownloadDetails.DocFileName,
            Blob: bucketResponse.data,
          };

          payload = {
            data: data.getUnsignedApprovalDocDownloadDetails,
            file,
          };
        } else {
          dispatch({
            type: GET_ASSIGNED_APPROVAL_DOCS_FAILED,
            payload: new Error('No document returned.'),
          });

          return;
        }
      }

      dispatch({
        type: GET_ASSIGNED_APPROVAL_DOCS_COMPLETED,
        payload,
      });
    } catch (err) {
      dispatch({
        type: GET_ASSIGNED_APPROVAL_DOCS_FAILED,
        payload: err,
      });
    }
  };
}

export default guestGetAssignedApprovalDocAction;
